module.exports = __webpack_public_path__ + "img/tab-1.423605da.png";